import { AlertTriangle, CheckCircle2 } from 'lucide-react';

export interface IntegrityFlag {
  label: string;
  tripped: boolean; // true = a concern was detected
}

interface Props {
  flags: IntegrityFlag[];
}

export default function IntegrityPills({ flags }: Props) {
  // Inner content only; SectionShell supplies the `integrity` anchor + eyebrow.
  return (
    <div className="POST__ANALYSIS__integrity">
      {flags.map((f) => (
        <span
          key={f.label}
          className={`POST__ANALYSIS__status ${f.tripped ? 'status-warn' : 'status-ok'}`}
        >
          {f.tripped ? <AlertTriangle size={13} /> : <CheckCircle2 size={13} />}
          {f.label}
        </span>
      ))}
    </div>
  );
}
